import React, { useState } from 'react';
import { Button } from 'semantic-ui-react';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const ExportButtonDuplicates = (props) => {
	const [loading, setLoading] = useState(false);
	let sortedData = props.data
	.sort((a,b) => {
		return a.created_date - b.created_date;
	}).map((record) => {
		const {created_date, ...rest} = record;
		return rest; 
	});

	const download = () => {
		setLoading(true);
		const ws = XLSX.utils.json_to_sheet(sortedData);
		const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
		var string1 = ws['B2'];
		var string2 = ws['BB2'];
        var string3 = ws['AN2']
		const myJsonString1 = JSON.stringify(string1);
		const stringResult1 = myJsonString1.replace(/\D/g,'');
		const myJsonString2 = JSON.stringify(string2);
		const DateString = myJsonString2.replace(/^(-)|[^0-9-]+/g, '$1');
		const stringResult2 = DateString.slice(0, -9);
        const myJsonString3 = JSON.stringify(string3);
        const shortenedString = myJsonString3.replace(/[^a-zA-Z0-9 ]/g, "");
        const stringResult3 = shortenedString.substring(3, 29);
		const buffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
		const blob = new Blob([buffer], {
			type:
				'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
		});

		FileSaver.saveAs(blob, `${stringResult1}-${stringResult3}-${stringResult2}.xlsx`);
		setLoading(false);
	};

	return (
		<Button
			loading={loading}
			color="black"
			size="small"
			icon="download"
			content="Exportar Datos"
			onClick={() => download()}
		/>
	);
};

export default ExportButtonDuplicates;
